import * as React from 'react';

import { __t, applyTranslations } from 'utils/language';

applyTranslations(require('./statistics-audience-overlap-error.i18n.json'));

type Props = {
  error: string
};

const StatisticsAudienceOverlapError = (
  {
    error
  }: Props
): JSX.Element => (
  <div className="statistics-audience-overlap-error">
    {
      __t(`statistics_audience_overlap_error.error.${error.replace('.', '_')}`) ||
      __t('statistics_audience_overlap_error.error.general_service_error')
    }
  </div>
);

export default StatisticsAudienceOverlapError;
